import { defineComponent as _defineComponent } from 'vue'
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { faPlay } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'JustwatchTVPlayBtn',
  props: {
    disable: { type: Boolean },
    providerShortName: null
  },
  setup(__props: any) {



return { __sfc: true,ProviderIcon, faPlay }
}

})